// Hex color values for all avatar creator color styles
// Mapped from the named colors in CharacterResources.js ColorStyles

export const ColorHexMap = {
    // ═══════════════════════════════════════════
    // SKIN COLORS (15 variations)
    // ═══════════════════════════════════════════

    // Main (base skin tone)
    PaleSkinColorMain: "#FDE7D6",
    LightSkinColorMain: "#F5D0A9",
    BeigeSkinColorMain: "#E8BA8B",
    OrangeBeigeSkinColorMain: "#D4A574",
    YellowSkinColorMain: "#C8A960",
    DarkYellowSkinColorMain: "#B89540",
    TannedSkinColorMain: "#B07845",
    RedSkinColorMain: "#C47A5A",
    AmberSkinColorMain: "#C68E3C",
    DarkAmberSkinColorMain: "#A67230",
    BrownSkinColorMain: "#8B5E3C",
    DarkBrownSkinColorMain: "#5C3A21",
    GreenSkinColorMain: "#7FB77E",
    GreySkinColorMain: "#A0A0A0",
    BlueSkinColorMain: "#7EA8D4",
    PinkSkinColorMain: "#F2B8C6",

    // Shade (darker variant for shadows)
    PaleSkinColorShade: "#E8CCBA",
    LightSkinColorShade: "#D4B08A",
    BeigeSkinColorShade: "#C9996E",
    OrangeBeigeSkinColorShade: "#B8895A",
    YellowSkinColorShade: "#A89040",
    DarkYellowSkinColorShade: "#987A30",
    TannedSkinColorShade: "#8E5E32",
    RedSkinColorShade: "#A86040",
    AmberSkinColorShade: "#A87428",
    DarkAmberSkinColorShade: "#885A20",
    BrownSkinColorShade: "#6E4528",
    DarkBrownSkinColorShade: "#3E2510",
    GreenSkinColorShade: "#5E9460",
    GreySkinColorShade: "#787878",
    BlueSkinColorShade: "#5E88B0",
    PinkSkinColorShade: "#D4909E",

    // Cheeks (blush tones)
    PaleSkinColorCheeks: "#F5A0A0",
    LightSkinColorCheeks: "#E89080",
    BeigeSkinColorCheeks: "#D88070",
    OrangeBeigeSkinColorCheeks: "#CC7060",
    YellowSkinColorCheeks: "#D08858",
    DarkYellowSkinColorCheeks: "#C07848",
    TannedSkinColorCheeks: "#C06845",
    RedSkinColorCheeks: "#D06050",
    AmberSkinColorCheeks: "#C87838",
    DarkAmberSkinColorCheeks: "#B06830",
    BrownSkinColorCheeks: "#A05838",
    DarkBrownSkinColorCheeks: "#7A3820",
    GreenSkinColorCheeks: "#90C888",
    GreySkinColorCheeks: "#B88888",
    BlueSkinColorCheeks: "#8090C0",
    PinkSkinColorCheeks: "#F090A8",

    // ═══════════════════════════════════════════
    // HAIR COLORS (20 variations)
    // ═══════════════════════════════════════════

    // Main
    BlondeHairColorMain: "#E8D44D",
    LightBlondeHairColorMain: "#F5E6A0",
    GoldenBlondeHairColorMain: "#DAB840",
    PlatinumHairColorMain: "#E8E0D0",
    SilverHairColorMain: "#C0C0C8",
    LightBrownHairColorMain: "#A07848",
    EspressoHairColorMain: "#5C3820",
    GarnetHairColorMain: "#8B2252",
    DarkBrownHairColorMain: "#3E2415",
    OrangeHairColorMain: "#E87830",
    GingerHairColorMain: "#C85828",
    CopperHairColorMain: "#B87333",
    ChestnutHairColorMain: "#954535",
    GreenHairColorMain: "#4CAF50",
    BlueHairColorMain: "#4090D0",
    PurpleHairColorMain: "#9040C0",
    HotPinkHairColorMain: "#FF1493",
    PinkHairColorMain: "#FF80AB",
    HotRedHairColorMain: "#E02020",
    BlackHairColorMain: "#1A1A1A",

    // Shade (darker variant)
    BlondeHairColorShade: "#C4A836",
    LightBlondeHairColorShade: "#D4C878",
    GoldenBlondeHairColorShade: "#B89830",
    PlatinumHairColorShade: "#C8C0A8",
    SilverHairColorShade: "#9898A0",
    LightBrownHairColorShade: "#7A5830",
    EspressoHairColorShade: "#3E2010",
    GarnetHairColorShade: "#6A1840",
    DarkBrownHairColorShade: "#281008",
    OrangeHairColorShade: "#C06020",
    GingerHairColorShade: "#A04018",
    CopperHairColorShade: "#905820",
    ChestnutHairColorShade: "#703020",
    GreenHairColorShade: "#2E7D32",
    BlueHairColorShade: "#2868A0",
    PurpleHairColorShade: "#6A2890",
    HotPinkHairColorShade: "#C01070",
    PinkHairColorShade: "#D06088",
    HotRedHairColorShade: "#B01818",
    BlackHairColorShade: "#0A0A0A",

    // ═══════════════════════════════════════════
    // OUTFIT COLORS (28 variations)
    // ═══════════════════════════════════════════

    // Main
    RedOutfitColorMain: "#E74C3C",
    SuperheroRedOutfitColorMain: "#CC0000",
    IndianRedOutfitColorMain: "#CD5C5C",
    SalmonOutfitColorMain: "#FA8072",
    OrangeOutfitColorMain: "#FF8C00",
    HazelWoodOutfitColorMain: "#C8A070",
    HoneyYellowOutfitColorMain: "#EBB02D",
    GoldOutfitColorMain: "#FFD700",
    GreenYellowOutfitColorMain: "#ADFF2F",
    DarkKhakiOutfitColorMain: "#BDB76B",
    MossOutfitColorMain: "#6B8E23",
    OliveOutfitColorMain: "#808000",
    GreenOutfitColorMain: "#28A745",
    SeaGreenOutfitColorMain: "#2E8B57",
    MintOutfitColorMain: "#3EB489",
    TurqoiseOutfitColorMain: "#40E0D0",
    LightSkyBlueOutfitColorMain: "#87CEFA",
    RoyalBlueOutfitColorMain: "#4169E1",
    AliceBlueOutfitColorMain: "#4682B4",
    AstronautGreyOutfitColorMain: "#6E7B8B",
    SlateGreyOutfitColorMain: "#708090",
    DarkSlateGreyOutfitColorMain: "#2F4F4F",
    LavenderOutfitColorMain: "#B57EDC",
    PurpleOutfitColorMain: "#8B008B",
    OrchidOutfitColorMain: "#DA70D6",
    PinkOutfitColorMain: "#FF69B4",
    HotPinkOutfitColorMain: "#FF1493",
    PaleVioletRedOutfitColorMain: "#DB7093",

    // Shade (darker)
    RedOutfitColorShade: "#C0392B",
    SuperheroRedOutfitColorShade: "#990000",
    IndianRedOutfitColorShade: "#A04040",
    SalmonOutfitColorShade: "#D06050",
    OrangeOutfitColorShade: "#CC7000",
    HazelWoodOutfitColorShade: "#A08050",
    HoneyYellowOutfitColorShade: "#C89020",
    GoldOutfitColorShade: "#D4B000",
    GreenYellowOutfitColorShade: "#88CC20",
    DarkKhakiOutfitColorShade: "#989250",
    MossOutfitColorShade: "#4E6818",
    OliveOutfitColorShade: "#606000",
    GreenOutfitColorShade: "#1E8035",
    SeaGreenOutfitColorShade: "#206840",
    MintOutfitColorShade: "#2E8868",
    TurqoiseOutfitColorShade: "#30B0A0",
    LightSkyBlueOutfitColorShade: "#60A0D0",
    RoyalBlueOutfitColorShade: "#3050B0",
    AliceBlueOutfitColorShade: "#346090",
    AstronautGreyOutfitColorShade: "#505A68",
    SlateGreyOutfitColorShade: "#506070",
    DarkSlateGreyOutfitColorShade: "#1E3838",
    LavenderOutfitColorShade: "#8A58B0",
    PurpleOutfitColorShade: "#600060",
    OrchidOutfitColorShade: "#B050A8",
    PinkOutfitColorShade: "#D04890",
    HotPinkOutfitColorShade: "#CC1078",
    PaleVioletRedOutfitColorShade: "#B05070",

    // Accent (lighter/contrast)
    RedOutfitColorAccent: "#FF6B5A",
    SuperheroRedOutfitColorAccent: "#FF3333",
    IndianRedOutfitColorAccent: "#E07878",
    SalmonOutfitColorAccent: "#FFB0A0",
    OrangeOutfitColorAccent: "#FFB040",
    HazelWoodOutfitColorAccent: "#E0C090",
    HoneyYellowOutfitColorAccent: "#FFD050",
    GoldOutfitColorAccent: "#FFE850",
    GreenYellowOutfitColorAccent: "#C8FF60",
    DarkKhakiOutfitColorAccent: "#D8D090",
    MossOutfitColorAccent: "#90B840",
    OliveOutfitColorAccent: "#A8A830",
    GreenOutfitColorAccent: "#48D068",
    SeaGreenOutfitColorAccent: "#48B070",
    MintOutfitColorAccent: "#60D8A8",
    TurqoiseOutfitColorAccent: "#70F0E0",
    LightSkyBlueOutfitColorAccent: "#B0E0FF",
    RoyalBlueOutfitColorAccent: "#6090FF",
    AliceBlueOutfitColorAccent: "#6898D0",
    AstronautGreyOutfitColorAccent: "#8898A8",
    SlateGreyOutfitColorAccent: "#90A0B0",
    DarkSlateGreyOutfitColorAccent: "#486868",
    LavenderOutfitColorAccent: "#D0A0F0",
    PurpleOutfitColorAccent: "#B030B0",
    OrchidOutfitColorAccent: "#F098E8",
    PinkOutfitColorAccent: "#FF90D0",
    HotPinkOutfitColorAccent: "#FF50B0",
    PaleVioletRedOutfitColorAccent: "#F090B0",

    // Shadow (darkest)
    RedOutfitColorShadow: "#8B2020",
    SuperheroRedOutfitColorShadow: "#660000",
    IndianRedOutfitColorShadow: "#7A2828",
    SalmonOutfitColorShadow: "#A04030",
    OrangeOutfitColorShadow: "#8B4500",
    HazelWoodOutfitColorShadow: "#705030",
    HoneyYellowOutfitColorShadow: "#8B6510",
    GoldOutfitColorShadow: "#8B7500",
    GreenYellowOutfitColorShadow: "#5A8810",
    DarkKhakiOutfitColorShadow: "#6B6538",
    MossOutfitColorShadow: "#354810",
    OliveOutfitColorShadow: "#404000",
    GreenOutfitColorShadow: "#105020",
    SeaGreenOutfitColorShadow: "#104028",
    MintOutfitColorShadow: "#185840",
    TurqoiseOutfitColorShadow: "#208070",
    LightSkyBlueOutfitColorShadow: "#385888",
    RoyalBlueOutfitColorShadow: "#203878",
    AliceBlueOutfitColorShadow: "#204060",
    AstronautGreyOutfitColorShadow: "#303840",
    SlateGreyOutfitColorShadow: "#384048",
    DarkSlateGreyOutfitColorShadow: "#102020",
    LavenderOutfitColorShadow: "#503070",
    PurpleOutfitColorShadow: "#300030",
    OrchidOutfitColorShadow: "#703868",
    PinkOutfitColorShadow: "#882858",
    HotPinkOutfitColorShadow: "#880848",
    PaleVioletRedOutfitColorShadow: "#702840",
};
